import { render, staticRenderFns } from "./reviewWidgetSmall.vue?vue&type=template&id=e66e8e68"
import script from "./reviewWidgetSmall.vue?vue&type=script&lang=js"
export * from "./reviewWidgetSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports